import 'angular:locale/data:ru';
import 'angular:locale/data:he-IL';
import 'angular:locale/data:en-US';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
